import { render, staticRenderFns } from "./CommissionMonthsTable.vue?vue&type=template&id=496f6d58"
import script from "./CommissionMonthsTable.vue?vue&type=script&lang=js"
export * from "./CommissionMonthsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports